<template>
  <div
    class="content "
    :class="{
      'loading-overlay loading-overlay-progress': donationsState !== 'ready',
    }"
  >
    <reports-menu
      :start-date="startDate"
      :end-date="endDate"
      v-on:update-date="updateDate"
      v-on:download="download"
      :isSearchBox="false"
    >
      <template v-slot:filter>
        <div class="text-right float-right px-8 sm:px-4 pt-3">
          <el-dropdown @command="selectEvent" trigger="click">
            <el-button
              type="primary"
              size="medium"
              class="w-max"
              style="min-width: 150px"
            >
              {{ (selectedEvent && selectedEvent.name) || "All Events" }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="selectedEventId" :command="null"
                >All Events</el-dropdown-item
              >
              <el-dropdown-item :command="-1">--</el-dropdown-item>
              <el-dropdown-item
                v-for="(event, index) in allEvents"
                :key="index"
                :command="index"
                >{{ event.name }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
    </reports-menu>

    <div class="px-8 md:px-4 pt-4 d-reports clearfix tab-donations">
      <div class="d-block donations-summary shadow-md rounded-md bg-white">
        <h3 class="title">
          <div class=" flex flex-wrap -mx-2">
            <div class="px-2 w-1/2">Event Ticket Orders</div>
            <div class="px-2 w-1/2 text-right ">
              <span>{{ selected(startDate, endDate) | intervalLabel }}</span>
            </div>
          </div>
        </h3>

        <div class="contacts-list campaign-donations-list">
          <div id="c-donations-table_wrapper">
            <el-table
              style="width: 100%"
              :default-sort="sorting"
              :data="itemsDataPage"
              :height="tableHeight + 110"
              v-on:sort-change="sortChange"
            >
              <template slot="empty">
                <div v-if="donationsState !== 'ready' || loading" slot="empty">
                  Loading data...
                </div>
                <div v-else class="empty-placeholder">
                  <img
                    :src="require('../../assets/paceholders/31.svg')"
                    alt="No results"
                  />
                  <h3>No Event Tickets Yet</h3>
                </div>
              </template>
              <el-table-column type="expand">
                <template #default="props">
                  <div>
                    <el-table :data="props.row.products" style="width: 100%">
                      <el-table-column
                        label=""
                        prop=""
                        width="250"
                        class="txt-blue"
                      >
                        <template #header>
                          <span class="txt-blue">Event Title</span>
                        </template>

                        <template slot-scope="product">
                          <span>
                            {{ product.row.event.name || "N/A" }}
                          </span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="Ticket Name"
                        prop="name"
                        min-width="200"
                        class="txt-blue"
                      >
                        <template #header>
                          <span class="txt-blue">Ticket Name</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="Qty"
                        prop="quantity"
                        min-width="150"
                        class="txt-blue"
                      >
                        <template #header>
                          <span class="txt-blue">Qty</span>
                        </template>
                      </el-table-column>
                      <el-table-column min-width="107">
                        <template #header>
                          <span>
                            <span class="txt-blue">
                              Price
                            </span>
                            <el-tooltip placement="top-start">
                              <template #content>
                                This price does not include fees covered for the
                                entire purchase. <br />So, the Amount and Price
                                may not be the same due to fees covered.
                              </template>
                              <font-awesome-icon
                                class="txt-blue"
                                :icon="['far', 'info-circle']"
                              />
                            </el-tooltip>
                          </span>
                        </template>
                        <template slot-scope="product">
                          <span>
                            ${{ ((product.row.cost || 0) / 100) | formatMoney }}
                          </span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="Date Created"
                prop="created_at"
                :sort-orders="['descending', 'ascending']"
                sortable="custom"
                width="160"
              >
                <template slot-scope="scope">
                  {{ scope.row.createdAt | dateFormat("MMM D, YYYY") }}
                  <div class="info">
                    {{ scope.row.createdAt | dateFormat("h:mma") }}
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                label="Name & Email"
                prop="_full_name"
                sortable="custom"
                :sort-orders="['ascending', 'descending']"
                min-width="300"
              >
                <template slot-scope="scope">
                  <div class="donor">
                    <span
                      >{{ scope.row.customer.firstName || "N/A" }}
                      {{ scope.row.customer.lastName || "N/A" }}</span
                    >
                    <div class="info">{{ scope.row.customer.email }}</div>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                label="Tickets"
                prop="tickets"
                sortable="custom"
                :sort-orders="['ascending', 'descending']"
                min-width="300"
              >
                <template slot-scope="scope">
                  <div class="donor">
                    <span>{{ scope.row.tickets }} </span>
                    <div class="info">Tickets</div>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                label="Amount"
                prop="amount"
                sortable="custom"
                :sort-orders="['descending', 'ascending']"
                min-width="150"
              >
                <template slot-scope="scope">
                  <span
                    >${{ (scope.row.cost / 100) | formatMoney }}<br />
                    <div style="display: inline-block" class="info">Amount</div>
                  </span>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              class="text-right"
              background
              :current-page.sync="currentPage"
              layout="prev, pager, next"
              :page-size="paginationInfo.pageSize"
              :total="itemsData.length"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>

    <donor-info
      v-if="showDonorInfo"
      :donor-id="showDonorId"
      v-on:close-info="showDonorInfo = false"
    ></donor-info>

    <receipt ref="receipt"></receipt>
  </div>
</template>

<script>
import { formatMoney } from "@/utils/utils";
import { EventsTickets } from "@/utils/api";
import ReportsMenu from "./menu.vue";
import DonorInfo from "../Parts/DonorInfo.vue";
import reportsMixin from "./reports-mixin";
import reportsMenuMixin from "./reports-menu-mixin";
import dataTableMixin from "../Parts/data-table-mixin";
import Receipt from "../Receipt";
import { mapActions, mapState } from "vuex";

const moment = require("moment");

export default {
  name: "ReportCampaigns",
  mixins: [reportsMixin, reportsMenuMixin, dataTableMixin],
  components: {
    ReportsMenu,
    DonorInfo,
    Receipt,
  },
  metaInfo: {
    title: "Reports - Tickets",
  },
  created() {
    this.sorting = { prop: "created_at", order: "descending" };
  },
  mounted() {
    Promise.all([this.getAllTicketList()]).then(() => {
      this.loading = false;
    });
  },
  methods: {
    getAllTicketList() {
      return EventsTickets.getAllTicketsList(this.activeCharityId).then(
        (response) => {
          this.eventsData = response.transactions;
        }
      );
    },
    handleCommand([command, payload]) {
      switch (command) {
        case "edit":
          this.openEditModal(payload);
          break;
      }
    },
    sortChange(sorting) {
      this.sorting = sorting;
    },
    selectEvent(index) {
      this.selectedEventId = index;
    },
    openEditModal(donationInfo) {
      this.selectedDonation = donationInfo;
      this.editParams.campaign_id = donationInfo.campaign_id;

      this.editModal = true;
    },
    editDonation(donationInfo) {
      this.$store
        .dispatch("donations/editDonationNode", {
          charityId: this.activeCharityId,
          donationId: donationInfo.id,
          params: { campaign_id: this.editParams.campaign_id },
        })
        .then(() => this.$message("Donation updated"))
        .catch((err) => alert(err));
    },
    ...mapActions("campaigns", ["updateCampaigns"]),
    async download(type) {
      const title =
        `Tickets to ` +
        ((this.selectedEvent && this.selectedEvent.name) || "All Events");

      let header = [
        "Date",
        "Time",
        ...(type === "csv" ? ["First Name", "Last Name"] : ["Name"]),
        "Email",
        ...(type === "csv" ? ["Type"] : []),
        "Tickets",
        ...(type === "csv"
          ? [
              "Address Line 1",
              "Address Line 2",
              "City",
              "State",
              "Zip Code",
              "Country",
              "Intended Amount",
              "Fees Covered",
            ]
          : []),
        "Total Amount",
      ];

      const body = this.itemsDataSorted.map((item) => {
        const dt = moment(item.createdAt);
        const product = item.products[0];
        const customer = item.customer;
        const address = item.shippingAddress;
        return [
          dt.format("MMM D, YYYY"),
          dt.format("h:mma"),
          ...(type === "csv"
            ? [customer.firstName, customer.lastName]
            : [customer.firstName + " " + customer.lastName]),
          customer.email,
          ...(type === "csv" ? [product.type] : []),
          item.tickets,
          ...(type === "csv"
            ? [
                address.line1,
                address.line2 || "",
                address.city,
                address.state,
                address.postalCode,
                address.country,
                "$" + formatMoney(item.intendedAmount / 100, 2, 9),
                "$" + formatMoney(item.coveredFee / 100, 2, 9),
              ]
            : []),
          "$" + formatMoney(item.cost / 100, 2, 9),
        ];
      });

      this.exportData(type, title, header, body, {
        0: { minCellWidth: 25 },
        1: { minCellWidth: 20 },
      });
    },
  },
  computed: {
    ...mapState({
      allCampaigns: (state) => state.campaigns.allCampaigns,
      donations: (state) => state.donations.donations,
      donationsState: (state) => state.donations.donationsState,
      activeCharityId: (state) => state.auth.activeCharityId,
      activeCharityInfo: (state) => state.charities.activeCharityInfo,
    }),
    allEvents() {
      return this.itemsData.reduce((reduced, item) => {
        reduced[item.products[0].productId] = item.products[0];

        return reduced;
      }, {});
    },
    firstDonationDate() {
      if (this.donations.length) {
        return moment(
          this.donations[this.donations.length - 1].created_at
        ).format("MM/DD/YYYY");
      }

      return false;
    },
    selectedEvent() {
      if (!this.allEvents || !this.selectedEventId) {
        return null;
      }

      if (this.selectedEventId === -1) {
        return { name: "--" };
      }

      return this.allEvents[this.selectedEventId];
    },
    itemsData() {
      let eventsData = JSON.parse(JSON.stringify(this.eventsData));

      if (this.selectedEventId || (this.startDate && this.endDate)) {
        eventsData = eventsData.filter((d) => {
          let returned = true;
          if (this.selectedEventId === -1 && !d.products[0].productId) {
            return true;
          }

          if (this.selectedEventId) {
            returned =
              Number(d.products[0].productId) === Number(this.selectedEventId);
          }

          if (this.startDate && this.endDate) {
            returned =
              returned &&
              moment(d.createdAt).isBetween(this.startDate, this.endDate, "()");
          }

          return returned;
        });
      }

      eventsData = eventsData.map((d) => ({
        ...d,
        intendedAmount:
          Number(d.coveredFee) > 0 ? d.cost - Number(d.coveredFee) : d.cost,
        coveredFee: Number(d.coveredFee),
        fees: parseFloat(d.stripeFee),
        netTotal: d.cost - parseFloat(d.stripeFee),
        tickets: d.products.reduce(
          (tickets, product) => tickets + product.quantity,
          0
        ),
      }));

      return eventsData;
    },
  },
  watch: {
    activeCharityId() {
      this.updateCampaigns({ charity_id: this.activeCharityId });
    },
  },
  data() {
    return {
      showDonorInfo: false,
      showDonorId: null,
      selectedEventId: null,

      selectedDonation: null,
      eventsData: [],

      editModal: false,

      editParams: {
        campaign_id: null,
      },
    };
  },
};
</script>
